(function() {
    var breadcrumb = document.querySelectorAll('.breadcrumb > li');

    if (breadcrumb[1]) {

        var section = breadcrumb[1].querySelector("a");

        if ( section ) {
            var sectionSlug = section.innerText.toLowerCase();
            var menuElement =  document.querySelectorAll('.header__primary-nav .hs-menu-wrapper > ul > li');

            for (var index = 0, maxElement = menuElement.length; index < maxElement; index++) {
                var element = menuElement[index].querySelector('a').innerText.toLowerCase();

                if (sectionSlug == element) {
                    menuElement[index].classList.add('active');
                    break;
                }

            }
        }
    }
})();
